<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import { computed, type ComputedRef } from "vue";
import type { TenantSummary } from "../api/tenants.js";
import AppShell from "../components/AppShell.vue";
import TenantMembersPanel from "../components/TenantMembersPanel.vue";
import { useTenantStore } from "../stores/tenants.js";

const tenantStore: ReturnType<typeof useTenantStore> = useTenantStore();
const tenant: ComputedRef<TenantSummary | null> = computed(
  (): TenantSummary | null => tenantStore.selectedTenant,
);
</script>

<template>
  <AppShell v-if="tenant">
    <header class="page-heading">
      <div>
        <p class="eyebrow">{{ tenant.displayName }}</p>
        <h1>Members</h1>
        <p>Roles and access apply only within this tenant.</p>
      </div>
    </header>
    <TenantMembersPanel :tenant-id="tenant.id" :max-users="tenant.tier.maxUsersPerTenant" />
  </AppShell>
</template>
